import styled from '@emotion/styled'

export const DraggableItemListWrapper = styled.div``
